// Opaque-origin frame: vendor globals/styles and pending requests end on close.
// No customer data, JWT, API keys or delivery prices enter this document.
export const yandexPickupWidgetDocument = `<!doctype html><html lang="ru">
<meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1">
<style>html,body,#map{width:100%;height:100%;margin:0;overflow:hidden}.ydw-widget,#ydw-map{height:100%!important}</style>
<div id="map"></div>
<script>
(() => {
  const send = (type, extra = {}) => parent.postMessage({ source: 'maxmarket-yandex-pickup', type, ...extra }, '*');
  let config, started = false, ready = false;
  const fail = () => send('error');
  const start = () => {
    if (started || !config || !window.YaDelivery?.createWidget) return;
    started = true;
    try {
      window.YaDelivery.createWidget({ containerId: 'map', params: {
        city: config.city || 'Москва', size: { height: innerHeight + 'px', width: '100%' }, show_select_button: true,
        filter: { type: ['pickup_point'], payment_methods: ['already_paid'], payment_methods_filter: 'or' }
      } });
    } catch { fail(); }
  };
  addEventListener('message', event => {
    if (event.source !== parent || event.data?.type !== 'maxmarket-pickup-init') return;
    config = { city: typeof event.data.city === 'string' ? event.data.city.slice(0, 200) : 'Москва' }; start();
  });
  document.addEventListener('YaNddWidgetLoad', start);
  document.addEventListener('YaNddWidgetPointSelected', event => {
    const id = event.detail?.id;
    if (typeof id === 'string' && /^[A-Za-z0-9_-]{1,128}$/.test(id)) send('selected', { providerId: id });
  });
  const poll = setInterval(() => {
    if (window.YaDelivery?.map) { clearInterval(poll); clearTimeout(deadline); ready = true; send('ready'); }
  }, 200);
  const deadline = setTimeout(() => { clearInterval(poll); if (!ready) fail(); }, 30000);
  addEventListener('resize', () => { try { window.YaDelivery?.map?.container?.fitToViewport(); } catch {} });
  const script = document.createElement('script');
  script.src = 'https://widget-pvz.dostavka.yandex.net/widget.js?v=2'; script.async = true; script.onerror = fail;
  document.head.appendChild(script);
})();
</script></html>`;
